export default function ClientRoute(route) {
    return ("/" + route);
}